import { BottomSheet, Box, Button, Divider, Image } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import type { FunctionComponent } from "react";
import { useStaticDataAtomValue } from "../../staticDataAtom";
import { MainPhotoBadge } from "./MainPhotoBadge";

interface Props {
    src: string;
    show: boolean;
    isMainPhoto: boolean;
    onClose: () => void;
    onMain: () => void;
    onRemove: () => void;
    hideMainPhoto?: boolean;
}

export const MobileMenu: FunctionComponent<Props> = ({
    src,
    isMainPhoto,
    show,
    onClose,
    onRemove,
    onMain,
    hideMainPhoto,
}) => {
    const {
        cmsData: {
            photo: { setAsMainPhoto, deleteThisPhoto },
        },
    } = useStaticDataAtomValue();

    const handleMain = () => {
        onMain();
        onClose();
    };

    const handleRemove = () => {
        onClose();
        setTimeout(onRemove, 320);
    };

    return (
        <BottomSheet
            title="Photo options"
            visible={show}
            onChange={onClose}
            closeButton={{
                "aria-label": "Close",
            }}
            p="16"
        >
            <VStack gap="16">
                <Box width="100%" position="relative" borderRadius="8" overflow="hidden">
                    {isMainPhoto && <MainPhotoBadge />}
                    <Image
                        alt="Property photo"
                        src={src}
                        borderRadius="8"
                        srcSet={src.startsWith("blob:") ? src : undefined}
                        width="100%"
                        objectFit="cover"
                        loading="lazy-blur"
                    />
                </Box>
                <Divider />
                {!hideMainPhoto && (
                    <Button
                        variant="label"
                        label={setAsMainPhoto}
                        width="parent-fit"
                        state={isMainPhoto ? "disabled" : "enabled"}
                        onClick={handleMain}
                    />
                )}
                <Button
                    variant="label"
                    hierarchy="secondary"
                    label={deleteThisPhoto}
                    leadingIcon="fill.symbol.bin"
                    width="parent-fit"
                    onClick={handleRemove}
                />
            </VStack>
        </BottomSheet>
    );
};
